import React from 'react';
import { createPortal } from 'react-dom';

function SubmitOverlay({ label, step }) {
  if (!label) return null;

  return createPortal(
    <div className="submit-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="submit-overlay-card">
        <div className="submit-overlay-visual" aria-hidden="true">
          <div className="submit-bridge">
            <span className="submit-pillar submit-pillar-a" />
            <span className="submit-deck" />
            <span className="submit-pillar submit-pillar-b" />
            <span className="submit-pillar submit-pillar-c" />
          </div>
          <div className="submit-orbit">
            <span /><span /><span />
          </div>
        </div>
        <p className="submit-overlay-label">{label}</p>
        <p className="submit-overlay-step">{step || 'Please wait…'}</p>
        <div className="submit-overlay-track">
          <div className="submit-overlay-fill" />
        </div>
      </div>
    </div>,
    document.body,
  );
}

export { SubmitOverlay };
